import { createAction } from '@reduxjs/toolkit';
export const logoutAction = createAction('@AUTH/USERLOGOUT/SUCCESS');
